/**
 * Shared types for @gencay-akademi/sentry-config.
 */
/**
 * Validate a Sentry DSN string. Returns true for any non-empty https(s)
 * URL whose hostname contains "sentry" or "ingest" — sufficient to catch
 * obvious misconfigurations without locking out self-hosted Sentry.
 *
 * Empty/undefined DSN is treated as "Sentry disabled" and returns false.
 */
export function isValidDsn(dsn) {
    if (!dsn)
        return false;
    try {
        const u = new URL(dsn);
        if (u.protocol !== 'https:' && u.protocol !== 'http:')
            return false;
        if (!u.username)
            return false; // public key is required
        return true;
    }
    catch {
        return false;
    }
}
